import React, { useContext, useEffect, useState, useMemo } from "react";
import { toast } from "react-toastify";
import http from "../Services/httpService";
import services from "../Services/noronServices";
import ConfirmDialog from './ConfirmDialog'
export default function DrowAreaUser({ points, getPoints, doClose }) {
  const [userArea, setUserArea] = useState({ id: 0, title: "1", items: [] });
  useEffect(() => {
    //console.log('drowUserPost',points);
    if (points != undefined)
      setUserArea({ ...userArea, items: points.map((item) => ({ id: 0, longitude: item[0], latitude: item[1] })) })
  }, [points])

  useEffect(() => {
    if (userArea.id != 0)
      userAreaGet(userArea.id);
    else
      getPoints([]);
  }, [userArea.id])

  const [isDeleteing, setIsDeleteing] = useState(false)
  const doDelete = async (id) => {
    if (id == "")
      return;
    setIsDeleteing(true);
    await services.UserAreaDelete(id)
      .then(({ data }) => {
        setIsDeleteing(false);
        if (data.errorCode != 0) {
          toast.error(data.message, { theme: "colored" });
          return
        }
        setUserArea({ ...userArea, id: 0, title: "" });
        getPoints([]);
        UserAreaList();
      })
      .catch(err => {
        setIsDeleteing(false);
      });
  }
  const [isloadUserAreaGet, setIsloadUserAreaGet] = useState(false)
  const userAreaGet = async (id) => {
    if (id == "")
      return
    setIsloadUserAreaGet(true);
    await services.UserAreaGet(id)
      .then(({ data }) => {
        setIsloadUserAreaGet(false);
        if (data.errorCode != 0) {
          toast.error(data.message, { theme: "colored" });
          return
        }
        let temp = data.payload.items.map((item) => ([item.x, item.y]))
        if (temp > 2) {
          temp[0] = temp[temp.length - 1];
        }
        getPoints(temp);
      })
      .catch(err => {
        setIsloadUserAreaGet(false);
      });
  }

  const [userAreaList, setUserAreaList] = useState([]);
  const [isloadUserAreaList, setIsloadUserAreaList] = useState(false)


  useEffect(() => {
    UserAreaList();
  }, [])


  const UserAreaList = async () => {
    setIsloadUserAreaList(true);
    await services.UserAreaList()
      .then(({ data }) => {
        setIsloadUserAreaList(false);
        if (data.errorCode != 0) {
          toast.error(data.message, { theme: "colored" });
          return
        }
        setUserAreaList(data.payload);
      })
      .catch(err => {
        setIsloadUserAreaList(false);
      });
  }

  const [confirmPost, setConfirmPost] = useState(false);
  const [isPostingUser, setIsPostingUser] = useState(false);
  const doPost = async (e) => {
    e.preventDefault();
    setIsPostingUser(true);

    await services.UserAreaPost(userArea)
      .then(async ({ data }) => {
        setIsPostingUser(false);
        if (data.errorCode != 0) {
          toast.error(data.message, { theme: "colored" });
          return
        }
        toast.dark('ثبت شد ');
        setConfirmPost(false);
        await UserAreaList();
        if (userArea.id == 0) {
          setUserArea({ ...userArea, id: data.payload });

        }
      })
      .catch(err => {
        setIsPostingUser(false);
      });
  }


  return (
    <>
      <ConfirmDialog show={confirmPost}
        title={`عنوانی برای محدوده مشخص شده انتخاب بفرمایید`}
        handleDo={doPost}
        handleCancel={(e) => setConfirmPost(false)}
        isBusy={isPostingUser}
      >
        <div className="row">
          <div className="col">
            <input className="form-control" name="title"
              value={userArea.title}
              onChange={e => http.handleChange(e, userArea, setUserArea)}
            />
          </div>
        </div>
      </ConfirmDialog>
      <div className="row">
        <div className="col-auto">
          <div className="d-flex align-items-center">

            <div className="input-group me-2  ">
              {/*<div className='input-group-text'>
               <label className='form-label me-2 mb-0'>محدوده</label>
                {isloadUserAreaList &&
                  <div className=" spinner-border spinner-border-sm" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                }
              </div>*/}

              <select
                className='form-select'
                name="id"
                value={userArea.id}
                onChange={e => http.handleChange(e, userArea, setUserArea)}
                disabled={isloadUserAreaGet}>
                <option value="0">محدوده جدید</option>
                {userAreaList.map((item, index) => <option value={item.id} key={index + "areal"}>{item.title}</option>)}
              </select>


              <button
                className='btn btn-primary '
                disabled={isPostingUser || isloadUserAreaGet}
                onClick={(e) => { setConfirmPost(true) }}
              >
                ثبت
                {isPostingUser &&
                  <div className="spinner-border spinner-border-sm" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                }
              </button>
              <button
                className="btn btn-success"
                onClick={e => {
                  e.preventDefault();
                  setUserArea({ ...userArea, id: 0, title: "" });
                  getPoints([]);
                  //setDeviceChoice([]);
                }}>
                جدید
              </button>

              <button className='btn btn-danger '
                disabled={isPostingUser || isloadUserAreaGet || isDeleteing || isloadUserAreaList}
                onClick={(e) => {
                  e.preventDefault();
                  if (userArea.id == 0)
                    getPoints([]);
                  else
                    doDelete(userArea.id)
                }}
              >
                {userArea.id != 0 ? "حذف" : "از نو"}
                {isDeleteing &&
                  <div className="spinner-border spinner-border-sm" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                }
              </button>

              <button
                onClick={doClose}
                className='btn btn-primary '>
                خروج
              </button>
            </div>
          </div>
        </div>
      </div>



    </>
  )
}

